import { ChemistryLitElement } from '@adornis/chemistry/chemistry-tailwind-lit-element.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { Status } from '@chancenwerk/shared/PresenceRecord.js';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { attendanceColor, attendanceIcon } from './board-component-attendance-card.js';

/**
 * @customElement bboard-component-attendance-legend
 */
@customElement('board-component-attendance-legend')
export class BoardComponentAttendanceLegend extends ChemistryLitElement {
  override render() {
    return html`<cr-flex horizontal space="sm" wrap>
      ${this._icon(Status.NOT_SURE, 'nicht gesetzt')} ${this._icon(Status.PRESENT, 'anwesend')}
      ${this._icon(Status.EXCUSED, 'entschuldigt')} ${this._icon(Status.MISSING, 'unentschuldigt')}
      ${this._icon(Status.PAUSED, 'pausiert')}
    </cr-flex>`;
  }

  private _icon(status: Status, text: string) {
    return html`<cr-flex horizontal crossaxis-center>
      <cr-icon ${css({ color: attendanceColor(this, status), fontSize: '26px', marginRight: this.spacing.sm })}
        >${attendanceIcon(status)}</cr-icon
      >
      <cr-text>${text}</cr-text>
    </cr-flex>`;
  }
}
